import { render, staticRenderFns } from "./ApprovalStatus.vue?vue&type=template&id=b7755358&scoped=true"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js"
import style0 from "./ApprovalStatus.vue?vue&type=style&index=0&id=b7755358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7755358",
  null
  
)

export default component.exports